import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Componentes
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import CadastroDiaNaoUteis from './components/CadastroDiaNaoUteis';

//Api
import diasNaoUteis_api from "../../../../api/diasNaoUteis_api"

//Helpers
import { showMessage, showQuestion } from '../../../../helpers/message';

//Context
import { useAuth } from '../../../../context/auth';

function DiasNaoUteis({ permissoes }) {
    //State para listar os dias não uteis
    const [diasNaoUteis, setDiasNaoUteis] = useState([]);

    //State para editar dia
    const [diasNaoUteis_id, setDiasNaoUteis_id] = useState(null);

    //State para criar dia
    const [diasNaoUteisNovo, setDiasNaoUteisNovo] = useState(false);

    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Context para loading
    const { setLoading } = useAuth();

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Descrição", objectValue: "descricao", align: "left" },
        { value: "Dia/Mês", objectValue: "diaMes", align: "left" }
    ];

    //Função que carrega a lista de documentos
    const loadDiasNaoUteis = () => {
        setLoading(true);
        diasNaoUteis_api.getList().then(response => {
            setDiasNaoUteis(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    const visualizar = (rowData) => {
        setDiasNaoUteis_id(rowData.id)
    }

    const editar = (rowData) => {
        setDiasNaoUteis_id(rowData.id);
    }

    const remover = (rowData) => {
        showQuestion("Tem certeza?", "tem certeza de que deseja deletar o cadastro?\n Esta ação é irreversível", "info",
            (confirmation) => {
                if (confirmation) {
                    setLoading(true);
                    diasNaoUteis_api.deleteItem(rowData).then(response => {
                        showMessage("Aviso", "Operação realizada com sucesso", "success", null);
                        loadDiasNaoUteis();
                    }).catch(e => showMessage("Erro", e.message, "error", null))
                        .finally(f => setLoading(false));
                }
            })
    }

    const actions = [
        ...editavel
        ?
        [actionsTable.editar(editar), actionsTable.remover(remover)]
        :
        [actionsTable.visualizar(visualizar)]
    ]

    useEffect(() => {
        loadDiasNaoUteis();
    }, []);

    const handleVoltar = () => {
        setDiasNaoUteis_id(null);
        setDiasNaoUteisNovo(false);
        loadDiasNaoUteis();
    }

    if (diasNaoUteisNovo || diasNaoUteis_id) {
        return <CadastroDiaNaoUteis
            editavel={editavel}
            id={diasNaoUteis_id}
            handleVoltar={handleVoltar}
        />
    }

    return <>
        <div className='d-flex align-items-center justify-content-between mb-4'>
            <h4 className='text-secondary m-0'>Dias não úteis</h4>
            {editavel &&
                <Button color='success' onClick={() => {
                    setDiasNaoUteisNovo(true);
                }}>+ Cadastrar
                </Button>
            }
        </div >
        <TabelaListagem
            actions={actions}
            title={"Lista de Dias Não Úteis"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={diasNaoUteis}
        />
    </>;
}

export default DiasNaoUteis;